import React from "react";
import { PageShell, EditableSection } from "./PageShell";

const SECTIONS = [
  { heading: "1. What we collect", body: "We collect the minimum required to fulfil your orders and improve our service: name, email, shipping address, phone number, order history, and — with your consent — anonymised browsing analytics." },
  { heading: "2. How we use it", body: "Your data is used to process orders, ship parcels, respond to enquiries, and (only if you opt in) send marketing emails. We do not sell, rent, or trade your personal data." },
  { heading: "3. Cookies & analytics", body: "We use Shopify’s standard cookies for cart and checkout function, and privacy-first analytics to understand which pages are most useful. Non-essential cookies only activate after your explicit consent — see our Cookie Policy for details." },
  { heading: "4. Third parties", body: "We share order details only with our shipping courier, payment processor, and email service provider. Each partner is bound by a Data Processing Agreement." },
  { heading: "5. Your rights (PIPEDA, GDPR & CCPA)", body: "You have the right to access, correct, port, or delete your data at any time. Email hello@scentodore.com with your request — we respond within 30 days." },
  { heading: "6. Retention", body: "Order records are retained for 7 years to satisfy Canadian tax and accounting requirements. Marketing consent records are held for as long as you remain subscribed. Analytics data is anonymised after 26 months." },
  { heading: "7. Children", body: "Scentodore is intended for customers of the age of majority in their jurisdiction. We do not knowingly collect data from minors. If you believe a minor has provided us with information, please contact us and we’ll remove it." },
  { heading: "8. Contact", body: "For privacy questions, please email hello@scentodore.com." },
];

export default function PrivacyPage() {
  return (
    <PageShell
      slug="privacy"
      testid="privacy"
      eyebrow="Legal"
      title="Privacy Policy"
      intro="Your data is yours. Here’s exactly what we collect, why, and what your rights are."
    >
      <EditableSection slug="privacy" sectionKey="clauses" fallback={SECTIONS} />
    </PageShell>
  );
}
